import React, {useContext} from "react";
import {TranslationsContext, FormContext} from "@proxy/_contexts";
import { Button, Modal } from "@proxy/_components";

const CheckoutModal = () => {

  const translations = useContext(TranslationsContext);
  const { styleVars, addToCartModalOpen } = useContext(FormContext);

  return (
    <div style={styleVars} className="gc__add_to_cart_modal_content">
      <div className="gc__add_to_cart_modal_notice">
        {(addToCartModalOpen) && (
          <div className="gc__swal2-icon gc__swal2-success gc__swal2-icon-show">
            <div className="gc__swal2-success-circular-line-left"></div>
            <span className="gc__swal2-success-line-tip"></span> <span className="gc__swal2-success-line-long"></span>
            <div className="gc__swal2-success-ring"></div> <div className="gc__swal2-success-fix"></div>
            <div className="gc__swal2-success-circular-line-right"></div>
          </div>
        )}

        <h2 className="gc__swal2-title" id="gc__swal2-title">
          {translations.checkout_redirect}
        </h2>
        <div className="gc__swal2-html-container">{translations.gift_card_issued_after_checkout}</div>
      </div>
    </div>
  );
};

const AddToCartModal = () => {

  const translations = useContext(TranslationsContext);
  const { styleVars, addToCartSuccess, addToCartModalOpen, setAddToCartModalOpen } = useContext(FormContext);

  const onClose = () => setAddToCartModalOpen(false);

  const handleShowCardButtonClick = () => {
    window.open('/cart', "_self");
  };

  return (
    <div style={styleVars} className="gc__add_to_cart_modal_content">
      <div className="gc__add_to_cart_modal_notice">
        {addToCartModalOpen && (
          <div className="gc__swal2-icon gc__swal2-success gc__swal2-icon-show">
            <div className="gc__swal2-success-circular-line-left"></div>
            <span className="gc__swal2-success-line-tip"></span> <span className="gc__swal2-success-line-long"></span>
            <div className="gc__swal2-success-ring"></div> <div className="gc__swal2-success-fix"></div>
            <div className="gc__swal2-success-circular-line-right"></div>
          </div>
        )}

        <h2 className="gc__swal2-title" id="gc__swal2-title">{
          addToCartSuccess
            ?
            translations && translations.added_to_cart_modal_success_notice
              ? translations.added_to_cart_modal_success_notice : "Success"
            :
            translations && translations.added_to_cart_modal_failure_notice
              ? translations.added_to_cart_modal_failure_notice : "Failed"
        }</h2>
        <div className="gc__swal2-html-container">{translations.gift_card_issued_after_checkout}</div>
      </div>
      <div className="gc__add_to_cart_modal_buttons">
        <Button
          type={"button"}
          fullWidth={true}
          onClick={handleShowCardButtonClick}
        >
        {translations.added_to_cart_modal_view_cart_button}
        </Button>
        <a role="button" href="#" onClick={onClose}>{translations.close}</a>
      </div>
    </div>
  );
};

const SubmitModal = () => {

  const { pricingConfig, addToCartModalOpen, setAddToCartModalOpen, formData } = useContext(FormContext);

  return (
    <Modal
      id="gcpAddToCartModal"
      title="Added to cart"
      open={addToCartModalOpen}
      onClose={() => setAddToCartModalOpen(false)}
    >
      {formData.id === "Custom"
        ? <CheckoutModal />
        : <AddToCartModal />
      }
    </Modal >
  );
};

export default SubmitModal;
